import React from 'react';

const Pay = () => {
    return (
        <div className="mt-5">
            <h2>Payment system is coming soon</h2>
        </div>
    );
};

export default Pay;